import { useQuery } from '@tanstack/react-query'
import { fetchGamesForWeek } from './api'

/* `live` opts into score polling. It is off by default so the picks page, which
   only needs the slate, does not start a timer -- and it is a per-observer
   option, so both pages still share the one ['games', weekId] cache entry.

   The interval is a function rather than a constant: it returns false unless
   something is actually being played, which stops the poll overnight and
   between weeks instead of hitting the database every five minutes for ever.
   'final' is not enough to stop on its own -- a week has finals and scheduled
   games sitting side by side all Sunday. */
export function useGamesForWeek(weekId: string | undefined, options?: { live?: boolean }) {
  return useQuery({
    queryKey: ['games', weekId],
    queryFn: () => fetchGamesForWeek(weekId!),
    enabled: Boolean(weekId),
    refetchInterval: options?.live
      ? (query) =>
          query.state.data?.some((game) => game.status === 'in_progress') ? 5 * 60_000 : false
      : undefined,
  })
}
